import { render, staticRenderFns } from "./integralitem.vue?vue&type=template&id=28e06072&scoped=true&"
import script from "./integralitem.vue?vue&type=script&lang=js&"
export * from "./integralitem.vue?vue&type=script&lang=js&"
import style0 from "./integralitem.vue?vue&type=style&index=0&id=28e06072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e06072",
  null
  
)

export default component.exports